var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "regist" }, [
    _c(
      "form",
      {
        ref: "changeUserinfoForm",
        attrs: { method: "post" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("input", {
          attrs: { name: _vm.dataCsrfName, type: "hidden" },
          domProps: { value: _vm.dataCsrf },
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { name: "token", type: "hidden" },
          domProps: { value: _vm.dataToken },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.jsonPatchForUserInfo,
              expression: "jsonPatchForUserInfo",
            },
          ],
          attrs: { name: "userinfo_patch", type: "hidden" },
          domProps: { value: _vm.jsonPatchForUserInfo },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.jsonPatchForUserInfo = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("user-info-form", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isConfirm,
              expression: "!isConfirm",
            },
          ],
          attrs: {
            step: _vm.step,
            "display-pattern": _vm.displayPattern,
            "is-display-agreement-check": false,
            userinfo: _vm.userInfoPatch,
          },
          on: { "alert-message": _vm.showMessage, next: _vm.next },
          scopedSlots: _vm._u([
            {
              key: "note",
              fn: function () {
                return [
                  _c("p", [
                    _vm._v("\n                    この内容で登録します。"),
                    _c("br"),
                    _vm._v(
                      "\n                    よろしければ登録ボタンをクリックしてください。\n                "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _vm.isConfirm
          ? _c("user-info-confirm", {
              attrs: {
                step: _vm.step,
                "display-pattern": _vm.displayPattern,
                userinfo: _vm.userInfoPatch,
              },
              on: { back: _vm.back },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }